import { render } from "./ModalDetailConstruction.vue?vue&type=template&id=b40780c4&scoped=true"
import script from "./ModalDetailConstruction.vue?vue&type=script&lang=js"
export * from "./ModalDetailConstruction.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-b40780c4"

export default script